// App.js

import Home from "./pages/Home";
import "./App.css";
import { QueryClientProvider, QueryClient } from "react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SearchRankings from "./pages/SearchRankings";
import SearchTournaments from "./pages/SearchTournaments";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import ClaimProfile from "./pages/ClaimProfile";
import PlayerDetails from "./pages/PlayerDetails";
import TournamentDetails from "./pages/TournamentDetails";
import AskRankings from "./pages/AskRankings";
import Clubs from "./pages/Clubs";
import HowRankingsWork from "./pages/HowRankingsWork";
import NotFound from "./pages/NotFound";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";

const queryClient = new QueryClient();

// Every public page is wrapped the same way; this keeps App.js from repeating
// the layout element for each route.
const page = (Component) => (
  <MainLayout>
    <Component />
  </MainLayout>
);

const auth = (Component) => (
  <AuthLayout>
    <Component />
  </AuthLayout>
);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={auth(Login)} />
          <Route path="/register" element={auth(Register)} />

          <Route path="/" element={page(Home)} />
          <Route path="/rankings" element={page(SearchRankings)} />
          {/* "Players" in the nav is the ranked player index. */}
          <Route path="/players" element={<Navigate to="/rankings" replace />} />
          <Route path="/players/:idOrSlug" element={page(PlayerDetails)} />
          <Route path="/searchTournaments" element={page(SearchTournaments)} />
          <Route path="/tournaments" element={<Navigate to="/searchTournaments" replace />} />
          <Route
            path="/tournamentDetails/:tournamentId"
            element={page(TournamentDetails)}
          />
          <Route path="/clubs" element={page(Clubs)} />
          <Route path="/how-rankings-work" element={page(HowRankingsWork)} />
          <Route path="/profile" element={page(Profile)} />
          <Route path="/claim" element={page(ClaimProfile)} />
          <Route path="/ask" element={page(AskRankings)} />

          <Route path="*" element={page(NotFound)} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
